import { render, staticRenderFns } from "./TriviaCategory.vue?vue&type=template&id=78836b9c&scoped=true"
import script from "./TriviaCategory.vue?vue&type=script&lang=js"
export * from "./TriviaCategory.vue?vue&type=script&lang=js"
import style0 from "./TriviaCategory.vue?vue&type=style&index=0&id=78836b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78836b9c",
  null
  
)

export default component.exports